import { createApp } from 'vue'
import OrgSearchNrSelect from '../src/pages/admin/org_search/org_search.vue'
import CpCreateApplication from '../src/pages/admin/org_search/cp_create_application.vue'
import { injectToasted } from '../src/utils/vue-toasted/inject_toasted'

const mountVueOrgSearch = () => {
  const clickedModal = document.getElementsByClassName('cp-organization')

  $(clickedModal).on('click', function (e) {
    const accountId = e.target.getAttribute('data-account-id')
    const modal = document.getElementById(`cp-organization-id-${accountId}`)
    const selectWrapper = modal?.querySelector(
      '#org-search-nr-select-wrapper'
    ) as HTMLElement
    const createApplicationWrapper = modal?.querySelector(
      '#cp-create-application-wrapper'
    ) as HTMLElement

    const app = createApp(OrgSearchNrSelect, { accountId })
    const app2 = createApp(CpCreateApplication, { accountId })

    injectToasted(app2)

    app.mount(selectWrapper)
    app2.mount(createApplicationWrapper)
  })
}

window.mountVueOrgSearch = mountVueOrgSearch

document.addEventListener('DOMContentLoaded', () => {
  mountVueOrgSearch()
})
